import {
  Component,
  Input,
  OnInit,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { HistoryListProperty } from '@app/core/model/historyListPropertyInput';

@Component({
  selector: 'app-history-mobile-list-item',
  templateUrl: './history-mobile-list-item.component.html',
  styleUrls: ['./history-mobile-list-item.component.scss'],
})
export class HistoryMobileListItemComponent {
  @Input()
  public obj: any;
  @Input()
  public actionTemplate: TemplateRef<any>;
  @Input()
  public properties: HistoryListProperty[];
  @Input()
  public titleProperty: string;
  @Input()
  public titleTemplate?: TemplateRef<any>;
  @Input()
  public subtitleTemplate?: TemplateRef<any>;

  public open: boolean;

  constructor() {
    this.open = false;
  }

  public toggleDetails(): void {
    this.open = !this.open;
  }

  public getDisplayedValue(obj: any, key: string): string {
    if (key.includes('.')) {
      return this.getNestedObject(obj, key.split('.'));
    } else {
      return obj[key] === '' ? undefined : obj[key];
    }
  }

  private getNestedObject(nestedObj, pathArr): string {
    return pathArr.reduce(
      (obj, key) => (obj && obj[key] !== 'undefined' ? obj[key] : undefined),
      nestedObj
    );
  }
}
